import { AddinCommandSurfaceItem, ContextMenuDataItemClick } from 'owa-addins-types';
import ContextMenuData from './ContextMenuData';
import getIconProps from '../components/SurfaceActionIconProps';
import {
    IContextualMenuItem,
    ContextualMenuItemType,
} from 'office-ui-fabric-react/lib/ContextualMenu';

export default class ContextMenuDataItem {
    public description: string;
    public accessibilityText: string;
    public subMenuData: ContextMenuData;
    public getClickHandler: ContextMenuDataItemClick;
    public iconUrl: string;
    constructor(protected key?: string, protected name?: string) {}

    public generateData(): AddinCommandSurfaceItem {
        return {
            key: this.key,
            name: this.name,
            title: this.description,
            ariaLabel: this.accessibilityText,
            iconProps: getIconProps(this.iconUrl),
            itemType: ContextualMenuItemType.Normal,
            getClickHandler: this.getClickHandler,
            subMenuProps: this.subMenuData
                ? {
                      items: [this.subMenuData.generateData() as IContextualMenuItem],
                  }
                : null,
        };
    }
}
